"use strict";

var BREAKPOINTS = {
  'tiny': 320,
  'small': 640,
  'medium': 850,
  'large': 1024,
  'widescreen': 1400
}

export default BREAKPOINTS;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/breakpoints.js
 **/